import { useDispatch, useSelector } from "react-redux";
import ComponentList from "./ComponentList"
import { useEffect } from "react";
import { listConveyor, unloadConveyorList } from "../../modules/conveyor/conveyorsSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import { initialize } from "../../modules/conveyor/conveyorWriteSlice";







const ComponentListContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const user = useSelector(state => state.user.user);
    const project = useSelector(state => state.project.project);
    const conveyors = useSelector(state => state.conveyors.conveyors);
    const loading = useSelector(state => state.loading);
    const error = useSelector(state => state.conveyors.error);

    /* 뒤로가기 등을 쭉 하다보면 리덕스에서 project가 지워지는 상황 발생. 이때는 전체 컨베이어가 뜨는 문제 발생 */
    if (!project) {
        navigate(`/projects`);
    }

    /* 처음 로딩할 때 리덕스에서 conveyorWrite 지우기 <- Drive Pulley 수정을 위해서 PulleyEditorFromContainer 빠져나올 때 초기화 하지 않았기 때문 */
    useEffect(() => {
        dispatch(initialize());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const tag = searchParams.get('tag');
        const page = parseInt(searchParams.get('page'), 10) || 1;
        const username = user ? user.username : null;
        const projectId = project?._id;
        
        dispatch(listConveyor({
            projectId,
            username,
            tag,
            page,
        }));

        return () => {
            dispatch(unloadConveyorList());
        }
        
    }, [dispatch, project?._id, searchParams, user]);

    const ownProject = (user && user._id) === (project && project.user._id);


    return (
        <ComponentList conveyors={conveyors} project={project} ownProject={ownProject} error={error} loading={!loading} />
    );
};

export default ComponentListContainer;